import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: 'http://api.bowling.suooter.com:8047', // url = base url + request url
  // baseURL: 'http://192.168.24.128:5001', // url = base url + request url

  // baseURL: 'http://www.supershooter.cn:8045', // url = base url + request url 测试路径
  // baseURL: `http://localhost:53165`, // url = base url + request url
  // baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers['Content-Type'] =
      'application/x-www-form-urlencoded; charset=UTF-8'
  
    // if (config.data && config.data.toString() === '[object FormData]') {
    //   // 必须加boundary  否则请求数据为payload 非form data
    //   const contentType =
    //     'multipart/form-data; boundary="' + new Date().getTime() + '"'
    //   config.headers['Content-Type'] = contentType
    // } else {
    //   config.headers['Content-Type'] =
    //     'application/x-www-form-urlencoded; charset=UTF-8'
    //   /*
    //    * 增加data参数转换，满足Content-Type为上面的情况
    //    * 否则发送过去的form-data为字符串*/
      config.transformRequest = [
        function(data) {
         
          let ret = ''
          for (const it in data) {
            ret +=
              encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }
      ]
    // }
    config.headers['Accept'] = '/'

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
    // if the custom code is not 20000, it is judged as an error.
    // if (res.resultValue.errCode !== 200) {
    //   if (res.resultValue.errCode === 201 || res.resultValue.errCode === 204||res.resultValue.errCode===412) {

    //     // 无数据
    //     // Message({
    //     //   message: res.resultValue.message,
    //     //   type: 'error',
    //     //   duration: 5 * 1000
    //     // })
    //   }
    //   if (res.resultValue.errCode === 401) {
    //     // 无数据
    //     Message({
    //       message: '身份信息失效，请重新登录！',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //   }
    //   if (res.resultValue.errCode === 403) {
    //     // 无数据
    //     Message({
    //       message: res.resultValue.message,
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //   }
    //   // if (res.resultValue.errCode === 412) {
    //   //   // 无数据
    //   //   Message({
    //   //     message: ' 提交信息有误，请检查提交信息！',
    //   //     type: 'error',
    //   //     duration: 5 * 1000
    //   //   })
    //   // }
    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     // MessageBox.confirm(
    //     //   '您已注销，您可以取消以停留在此页，或重新登录',
    //     //   '确认注销',
    //     //   {
    //     //     confirmButtonText: '重新登录',
    //     //     cancelButtonText: '取消',
    //     //     type: 'warning'
    //     //   }
    //     // ).then(() => {
    //     //   store.dispatch('user/resetToken').then(() => {
    //     //     location.reload()
    //     //   })
    //     // })
    //   }
    //   if (res.statusCode === 500 && response.config.url.indexOf('ImportAthletes') !== -1) {
    //     // Message({
    //     //   message: '文件格式错误，请检查文件格式',
    //     //   type: 'error',
    //     //   duration: 5 * 1000
    //     // })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    console.log(document.getElementsByClassName('el-message').length) // for debug
    // if (document.getElementsByClassName('el-message').length === 0) {
    //   Message({
    //     message: '暂无数据，请检查网络',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }

    return Promise.reject(error)
  }
)

export default service
